export const getUserToken = () =>
{
  let _userDetails = localStorage.getItem("user-details");

  if (_userDetails)
  {
    try
    {
      const parsedAuth = JSON.parse(_userDetails);
      return parsedAuth;
    } catch (error)
    {
      return {};
    }
  }
  // return userDetails ? JSON.parse(userDetails) : {};
};
